// extracted by mini-css-extract-plugin
export default {"btnWrap":"ShareButton_btnWrap__FteJE"};